import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAboutFeature, LazyAboutServiceCard, LazyCommonBackButton, LazyCommonCalender, LazyCommonCustomSpinner, LazyCommonDateSelector, LazyCommonDocCard, LazyCommonFloatingImage, LazyCommonPageHeader, LazyCommonPhoneInput, LazyCommonSelect, LazyCommonSelectButton, LazyCommonTimeSelector, LazyFooter, LazyHeader, LazyHomeContactForm, LazyHomeDoctorsCarousel, LazyHomeBooking, LazyHomeSectionOne, LazyHomeSectionThree, LazyHomeSectionTwo, LazyHomeServiceCard, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["AboutFeature", LazyAboutFeature],
["AboutServiceCard", LazyAboutServiceCard],
["CommonBackButton", LazyCommonBackButton],
["CommonCalender", LazyCommonCalender],
["CommonCustomSpinner", LazyCommonCustomSpinner],
["CommonDateSelector", LazyCommonDateSelector],
["CommonDocCard", LazyCommonDocCard],
["CommonFloatingImage", LazyCommonFloatingImage],
["CommonPageHeader", LazyCommonPageHeader],
["CommonPhoneInput", LazyCommonPhoneInput],
["CommonSelect", LazyCommonSelect],
["CommonSelectButton", LazyCommonSelectButton],
["CommonTimeSelector", LazyCommonTimeSelector],
["Footer", LazyFooter],
["Header", LazyHeader],
["HomeContactForm", LazyHomeContactForm],
["HomeDoctorsCarousel", LazyHomeDoctorsCarousel],
["HomeBooking", LazyHomeBooking],
["HomeSectionOne", LazyHomeSectionOne],
["HomeSectionThree", LazyHomeSectionThree],
["HomeSectionTwo", LazyHomeSectionTwo],
["HomeServiceCard", LazyHomeServiceCard],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
